import { map, slice } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import {
  DESKTOP_SHOW_TAG_ROWS,
  MOBILE_SCREEN_MAX_WIDTH,
  MOBILE_SHOW_TAG_ROWS,
  TAG_READ_MORE_BUTTON_WIDTH,
} from '../../common/helpers/constants';
import { getVisibleTagsCount } from './tagCountHelper';
import { useWindowSize } from '../../common/helpers/utility/useWindowSize';
import commonText from '../../locales/th/common.json';
import ShowMore from '../showMore/ShowMore';
import { TagsItem, TagsWrapper } from './Tags.style';
import { Tag } from '../../queries/fragments/project';

interface TagsProps {
  postingDataTags?: Tag[];
  projectDataTags?: Tag[];
  isOnProjectPage?: boolean;
}
const Tags: React.FC<TagsProps> = ({
  postingDataTags,
  projectDataTags,
  isOnProjectPage,
}) => {
  const dataTags = isOnProjectPage ? projectDataTags : postingDataTags;
  const [isShowMore, setIsShowMore] = useState(false);
  const [showTagFields, setShowTagFields] = useState(dataTags);
  const showMoreText = commonText.showMore.More;
  const windowSize = useWindowSize();
  const tagRef = useRef(null);
  const tagChildRef = useRef([]);

  useEffect(() => {
    if (tagRef.current && tagChildRef.current) {
      const maxWidth = tagRef.current.clientWidth;
      let maxRow = DESKTOP_SHOW_TAG_ROWS;
      let extraStyleWidth = 0;
      if (windowSize && windowSize.width < MOBILE_SCREEN_MAX_WIDTH) {
        extraStyleWidth = 32; // This the additional padding that is used for mobile. If it converted to margin no need to declare it here. TODO later
        maxRow = MOBILE_SHOW_TAG_ROWS;
      }
      const maxOffSetWidth = maxWidth - extraStyleWidth;
      const allPossibleChilds = Array.from(tagChildRef.current);
      const presentTags = allPossibleChilds.filter(function (e) {
        return e;
      });
      const tagIndex = getVisibleTagsCount({
        presentTags,
        maxOffSetWidth,
        maxRow,
        moreBtnWidth: TAG_READ_MORE_BUTTON_WIDTH,
      });
      if (dataTags.length > tagIndex) {
        const showTagFields = slice(dataTags, 0, tagIndex);
        setIsShowMore(true);
        setShowTagFields(showTagFields);
      } else {
        setShowTagFields(dataTags);
      }
    }
  }, [windowSize, dataTags]);

  const showMoreInfo = () => {
    setShowTagFields(dataTags);
    setIsShowMore(false);
  };

  return (
    <TagsWrapper
      ref={tagRef}
      isOnProjectPage={isOnProjectPage}
      data-test={'tags'}
    >
      {map(showTagFields, (item: Tag, i) => {
        return (
          <TagsItem
            ref={(el) => {
              tagChildRef.current[i] = el;
            }}
            key={i}
            data-test={'tag-item-' + i}
          >
            <a href={`/tag/${item.slug}/`}>{item.name}</a>
          </TagsItem>
        );
      })}
      {isShowMore && (
        <ShowMore
          isUsedForTag={true}
          isBeforeShowButtonWrapper={false}
          showMoreText={showMoreText}
          className="detail-show-more"
          showMoreInfo={showMoreInfo}
        />
      )}
    </TagsWrapper>
  );
};

export default Tags;
